import FixedNavigation from './navigation/fixed';
import MobileNavigation from './navigation/mobile';
import SubNavigation from './navigation/sub';
import TextImageColumns from './text-image-columns';
import MobileTooltip from './mobile-tooltip';
import Tabs from './tabs';
import { Slider } from '@parship/psg-slider';
import Table from './table';

new FixedNavigation();
new MobileNavigation();
new TextImageColumns();
new Table();

let nodes: NodeListOf<HTMLElement>;

nodes = document.querySelectorAll('.slider.adviser');
nodes.forEach((node: HTMLElement) => {
	new Slider({ target: node, itemsPerView: 1, loop: true });
});

nodes = document.querySelectorAll('.slider.tips');
nodes.forEach((node: HTMLElement) => {
	new Slider({ target: node, itemsPerView: -1 });
});

nodes = document.querySelectorAll('.studies-slider');
nodes.forEach((node: HTMLElement) => {
	new Slider({ target: node, itemsPerView: 1, loop: true });
});

nodes = document.querySelectorAll('.slider.local-dating');
nodes.forEach((node: HTMLElement) => {
	new Slider({
		target: node,
		itemsPerView: -1,
	});
});

nodes = document.querySelectorAll('.slider.story');
nodes.forEach((node: HTMLElement) => {
	new Slider({
		target: node,
		itemsPerView: 1,
		loop: true,
	});
});

nodes = document.querySelectorAll(
	'.current-menu-item .sub-menu-wrapper, .current-menu-parent .sub-menu-wrapper'
);
nodes.forEach((item: HTMLElement) => {
	new SubNavigation(item);
});

nodes = document.querySelectorAll('.show-tooltip');
if (nodes.length) {
	new MobileTooltip(nodes);
}

nodes = document.querySelectorAll('.wp-block-eharmony-tabs');
nodes.forEach((tab) => new Tabs(tab));

nodes = document.querySelectorAll('a[rel="footnote"]');
nodes.forEach((item: HTMLElement) => {
	item.addEventListener('click', (event: Event) => {
		const target: HTMLAnchorElement = event.target as HTMLAnchorElement;
		const details: Element = document.querySelector('.widget__footnotes details');
		if (details) {
			details.setAttribute('open', '');
			document
				.getElementById(target.hash.substring(1))
				?.scrollIntoView({ behavior: 'smooth' });
		}

		const buttonFootnotes: HTMLButtonElement = document.querySelector(
			'.tab-navigation button.footnotes'
		);
		if (buttonFootnotes) {
			buttonFootnotes.click();
		}
	});
});
